module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/horizontal-64b47c71d63d7e1f195d44ece4997049.svg";